import {grey400} from 'material-ui/styles/colors';

const styles = {
    toggleDiv: {
      maxWidth: 300,
      marginTop: 40,
      marginBottom: 5
    },
    toggleLabel: {
      color: grey400,
      fontWeight: 100
    },
    buttons: {
      marginTop: 30,
      float: 'right'
    },
    saveButton: {
      marginLeft: 5
    },
    refresh: {
      display: 'inline-block',
      position: 'relative',
    },
    operationButton:{
      float: 'right'
    }
  };

export default styles;


// WEBPACK FOOTER //
// ./src/components/search/styles/SearchFormStyles.js